import webhooksReducer from "./reducer"
import webhooksSagas from "./sagas"

const saga = {
  reducers: webhooksReducer,
  sagas: webhooksSagas
}

export default saga